export default __webpack_public_path__ + "static/media/kobiton.d3053ec9.svg";